
import React from 'react'
import Icon from 'react-icon-base'

const MdiPlus = props => (
    <Icon viewBox="0 0 24.00 24.00" {...props}>
        <g>
	<path strokeWidth="0.2" strokeLinejoin="round" d="M 18.9994,12.998L 12.9994,12.998L 12.9994,18.998L 10.9994,18.998L 10.9994,12.998L 4.99936,12.998L 4.99936,10.998L 10.9994,10.998L 10.9994,4.99805L 12.9994,4.99805L 12.9994,10.998L 18.9994,10.998L 18.9994,12.998 Z "/>
</g>
    </Icon>
)

export default MdiPlus
